import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { MultiSelectItem } from '@/main/store/@types/dropdown.d';

import { EditableStatus } from '#components/constants';

import { NAME as name, CRUMB_LABEL_KEY, DEPENDENT_TABLES as depTableNames, VOJ, ALTERNATIVY_VOJ } from '../constants';
import { apiProvider } from '../api';

export type VyrobkyMultiSelectItem = {
	Value: string,
	UpdateStatus: EditableStatus
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		BbBid: [],
		Kontexty: [],
		Vyrobky: [],
	},
	edit: {
		OjId: null as number | null,
		ObchodnikNr: null as string | null,
		SmlservNr: null as number | null,
		SmlobchNr: null as number | null,
		Text: null as string | null,
		BbParty: null as string | null,
		BbBid: null as string | null,
		BbCountry: null as string | null,
		Kontexty: [] as MultiSelectItem[],
		Vyrobky: [] as VyrobkyMultiSelectItem[],
		CanEditKontexty: null as boolean | null,
		CanEditVyrobky: null as boolean | null,
		EdfsUsername: null as string | null,
		EdfsPassword: null as string | null,
		TripodUsername: null as string | null,
		TripodPassword: null as string | null,
		MerchantId: null as string | null,
		HashKey: null as string | null,
		HashIV: null as string | null,
		IsGUIEnabled: null as boolean | null,
		ACategory: null as number | null,
		BCategory: null as number | null,
		CCategory: null as number | null,
		FCategory: null as number | null,
		MCategory: null as number | null,
		SCategory: null as number | null,
		AudatexPassw: null as string | null,
		AudatexUsername: null as string | null,
		IsEdfsEnabled: null as boolean | null,
		AccountReceivablePrefix: null as string | null,
	},
	depTableNames,
	depTableSettings: {
		[VOJ]: {
			filter(state) {
				return state.localState.showByVoj && {
					masterId: state.edit.OjId,
				};
			},
		},
		[ALTERNATIVY_VOJ]: {
			filter(state) {
				return {
					masterId: state.localState.currentRowVoj,
				};
			},
		},
	},
	localState: {
		currentRowVoj: null as number | null,
		showByVoj: true,
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
	},
});
